import { useCallback, useState } from "react";

export const useTooltip = (delayMs: number = 1000) => {
  const [isOpen, setIsOpen] = useState(false);

  const openWithAutoClose = useCallback(() => {
    setIsOpen(true);
    window.setTimeout(() => {
      setIsOpen(false);
    }, delayMs);
  }, [setIsOpen, delayMs]);

  return { isOpen, openWithAutoClose };
};
